import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { openMenu, openSearch, closeSearch } from './actions';
import { isSearchVisible } from './reducer';
import './NavBar.css';
import { ShoppingCart as ShoppingCartIcon, ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { styled, withStyles } from '@mui/styles';
import { AppBar, Box, Toolbar, IconButton, Typography, Badge, BadgeProps } from '@mui/material';
import MenuIcon from '../icons/MenuIcon';
import { matchPath, withRouter, Link, Redirect } from 'react-router-dom';
import { GetProfile } from '../../assets/redux/UserProfileRedux';
import { getCartItems } from '../../assets/redux/CartItemRedux';
import { getAuth } from '../../assets/redux/AuthRedux';
import { getTitle } from '../../assets/redux/NavbarTitleRedux';
import { History, LocationState } from "history";
import { RouteComponentProps } from 'react-router';
import { CartItemDto } from '../../dto/auth.dto';
import { StyledBadge } from '../StyledBadge';
const styles = (theme: any) => ({
  root: {  
    margin:"0 auto",
    width:"100%"
  },
  appBar: {
    backgroundColor: theme.color.appBarBackgroundColor,
   left:"unset !important",
    maxWidth:"769px !important",
  },
  menuIcon: {
    color: "white !important",
  },
  title: {
    color: "white !important",
    fontSize: "13pt"
  },
  pic: {
    width: "80px",
    height: "35px"
  },
  customBadge: {
    backgroundColor: "#e0e0e0 !important",
   color:"black !important"
  }
});
interface Iprops extends React.Props<any> {
  history: History<LocationState>;
  match: match<RouteComponentProps>;
  closeSearch: Function,
  openSearch: Function,
  openMenu: Function,
  searchVisible: any,
  location: any,
  profile: any,
  auth: any,
  classes: any,
  navbarTitle: any,
  cardItems: Array<CartItemDto>
}
interface IState {
  search: string,
  toSearchPage: string,
}
export interface match<P> {
  params: P;
  isExact: boolean;
  path: string;
  url: string;
}
class NavBar extends Component<Iprops, IState>  {
  constructor(props: any) {
    super(props);

    this.state = {
      search: '',
      toSearchPage: '',

    };

    this.showSidebar = this.showSidebar.bind(this);
    this.setSearch = this.setSearch.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.openSearch = this.openSearch.bind(this);

  }



  setSearch(e: any) {
    this.setState({ search: e.target.value });
  }

  /**
   * Handle search form submit.
   * Set state for redirecting to search page and close search box.
   */
  handleSubmit() {
    this.setState({ toSearchPage: this.state.search, search: '' }, () => this.props.closeSearch());
  }

  /**
   * Open search box when icon is clicked.
   * Reset search input and redirect when the search is opened.
   */
  openSearch() {
    this.setState({ toSearchPage: '', search: '' }, () => this.props.openSearch());
  }

  showSidebar(e: any) {
    e.stopPropagation();
    this.props.openMenu();
  }

  render() {
    const { searchVisible, location, profile, auth, classes, navbarTitle } = this.props;

    return (

      <Box flexGrow={1}   className={classes.root} >
        <AppBar position="fixed" className={classes.appBar} sx={{left:"unset"}} >
          <Toolbar >
            <IconButton
              size="medium"
              edge="start"
              className={classes.menuIcon}
              aria-label="menu"
              onClick={this.showSidebar}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" component="div" className={classes.title} >
              {navbarTitle ? navbarTitle : "EMS"}
            </Typography>
            <Box display="flex">


              <IconButton
                size="medium"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={e => this.props.history.replace('/app/cartPage')}
                className={classes.menuIcon}
              >
                <StyledBadge classes={{ badge: classes.customBadge }} badgeContent={this.props.cardItems.length} color='secondary'    >
                  <ShoppingCartIcon fontSize="large" />
                </StyledBadge >
              </IconButton>
              <IconButton
                size="medium"
                style={{ marginRight: "10px" }}
                onClick={e => this.props.history.goBack()}
                className={classes.menuIcon}
              >

                <ArrowBackIcon fontSize="large" />

              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
      </Box>
    );
  }
}



const mapStateToProps = (state: any) => ({
  searchVisible: isSearchVisible(state.navbar),
  profile: GetProfile(state.ProfileRedux),
  auth: getAuth(state.AuthRedux),
  navbarTitle: getTitle(state.NavbarTitleRedux),
  cardItems: getCartItems(state.CartRedux)
});

export default
  connect(
    mapStateToProps,
    { openMenu, openSearch, closeSearch },
  )(withStyles(styles, { withTheme: true })(withRouter(NavBar as any)));


